import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const defaultRoutes = [
  {
    path: '/not-found',
    name: 'not-found',
    component: () => import('@/views/NotFound.vue'),
  },
  {
    path: '/cards/:slug/:token?',
    name: 'card',
    component: () => import('@/views/Card.vue'),
  },
  {
    path: '/persons/:slug/:token?',
    name: 'person',
    component: () => import('@/views/Person.vue'),
  },
  {
    path: '/card_containers/:type/:slug/:token?',
    name: 'card_container',
    component: () => import('@/views/CardContainer.vue'),
  },
  {
    path: '/tag/:name',
    name: 'tag',
    component: () => import('@/views/Tag.vue'),
  },
  {
    path: '/collections/:slug',
    name: 'collection',
    component: () => import('@/views/Collection.vue'),
  },
  {
    path: '/references/:id',
    name: 'reference',
    component: () => import('@/views/Reference.vue'),
  },
  {
    path: '/posts',
    name: 'posts',
    component: () => import('@/views/Posts.vue'),
  },
  {
    path: '/references',
    name: 'references',
    component: () => import('@/views/References.vue'),
  },
  {
    path: '/cards',
    name: 'cards',
    component: () => import('@/views/Cards.vue'),
  },
  {
    path: '/persons',
    name: 'persons',
    component: () => import('@/views/Persons.vue'),
  },
  {
    path: '/archives',
    name: 'archives',
    component: () => import('@/views/Archives.vue'),
  },
  {
    path: '/archives/:slug/:token?',
    name: 'archive',
    component: () => import('@/views/Archive.vue'),
  },
  {
    path: '/card_containers/:type',
    name: 'card_containers',
    component: () => import('@/views/CardContainers.vue'),
  },
  // questo dovrei metterlo in un plugin "ereditaculturali"
  {
    path: '/places',
    name: 'places',
    component: () => import('@/views/Places.vue'),
  },
  {
    path: '/collections',
    name: 'collections',
    component: () => import('@/views/Collections.vue'),
  },
  { 
    path: '*', 
    name: 'fallback-page',
    component: () => import('@/views/NotFound.vue')
  },
  // {   
  //   path: '/ar',
  //   name: 'ar',
  //   component: () => import('@/views/touch/ARViewNew.vue'),
  // },
]

const createRouter = () => new Router({
  mode: 'history',
  base: process.env.VUE_APP_BASE_PATH || '/',
  linkActiveClass: "",
  routes: defaultRoutes
})

const router = createRouter()

// 2. Esportiamo la funzione di reset
// Questa funzione sovrascrive il "matcher" del router attuale con quello di uno nuovo
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher 
}

export default router
